import * as React from "react";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DefaultLayoutId } from "@bizform/type/model/component_element/DefaultLayoutId.model";
import { DataType } from "@bizform/type/model/model/DataType.model";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { BfLabel } from "./BfLabel";


type Props = {
};

/**
 * @since 0.0.1
 * @author Byungmin Choi, Hwansoon Park
 * @class BfLabel
 * @description BfLabel component element
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfHtmlElement extends BfLabel {
    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_V4GqtFc2inaKTzRdKU6h7FJbesf0_qm",
        category: ComponentCategory.LABEL,
        label: "Html Element",
        description: "Html Element like as div, p, a and so on",
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        icon: "",
        dataType: [DataType.STRING],
        property: null
    };

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfHtmlElement)
    static init(): ComponentElement<null> {
        return;
    }

    constructor(props?: Props) {
        super(props);
    }

    protected _render(): React.ReactNode {
        const v = {...this.state.wrappedCompState} as any;
        const html = v.useCustomLabel ? v.labelData : null;
        const value = !v.useCustomLabel ? v.labelData : null;
        const Tag = (v.tagName ? v.tagName.toLowerCase() : "div") as keyof JSX.IntrinsicElements;
        delete(v.labelData);
        delete(v.useCustomLabel);
        delete(v.label);
        delete(v.tooltipAttribute);
        delete(v.tagName);
        return (
            React.createElement(Tag, {
                ...v,
                key: this.elementId,
                id: this.elementId,
                ref: this._setRef,
                style: {...v.style},
                className: v.className,
                dangerouslySetInnerHTML: (html ? {__html: html} : null)
            }, value)
        );
    }
}
